import { RootHeader } from "@/components/RootHeader";
import moduelStyles from "./index.module.scss";
import tradePoster from "@/assets/@2x/images/market-poster.png";
import { cn } from "@/libs";
import styles from '../index.module.scss';
import { Button } from "antd-mobile";
import { useLogic } from "./useOutLogic";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { DynamicForm } from "../components/DynamicForm";
import { changeUsdtFormItems } from "./data";
import { DialogLocal } from "@/components/Dialog";
import { ContentTabs } from "../components/ContentTabs";
import { FormTabs } from "./formTabs";
import { CryptoTradingProvider } from "@/stores/cryptoTradingContext";
const DialogContent = () => {
  return <div className={moduelStyles.FooterTips} data-sentry-component="DialogContent" data-sentry-source-file="outCrypto.tsx"><p>1.交易过程中实时留意订单状态，十分钟内完成</p><p>2.购买时，付款成功后立即上传成功截图并点击「我已转账」</p><p>3.出售时务必确定收到款项再进行打币</p><p>4.订单出现异议第一时间点击右上角申请人工介入</p><p>5.未按规定操作，平台不承担任何责任</p></div>;
};
const FooterTips = () => {
  return <div className={moduelStyles.FooterTips} data-sentry-component="FooterTips" data-sentry-source-file="outCrypto.tsx"><p className={moduelStyles.tip_header}>重要提醒：</p><p>1.交易中请实时留意订单状态；</p><p>2.请确保您收币地址的主网与平台支持的主网一致【Tronscan(TRC20)】，否则可能造成资产丢失；</p><p>3.V币汇率锚定人民币汇率，平台使用实时汇率；</p><p>4.请仔细核实您的收U地址是否实际到账，以及到账数量，如到账数量有误、未到账或交易被拒绝且V币没有返还，请及时联系在线客服。</p></div>;
};
export const Wrapper = () => {
  const logic = useLogic();
  const navidate = useNavigate();
  const formFooter = useMemo(() => {
    return <div className={moduelStyles.footer}>
      <Button className={"common-submit-button"} onClick={() => {
        logic.onSubmit();
      }}>
        {logic.isTrading ? '查看订单' : '提交订单'}
      </Button>
    </div>;
  }, [logic.isTrading]);
  const showDialog = () => {
    DialogLocal({
      closeOnMaskClick: false,
      title: "交易须知",
      content: <DialogContent />
    });
  };
  return <div className={styles.pageTrade} data-sentry-component="Wrapper" data-sentry-source-file="outCrypto.tsx">
    <RootHeader title={'区块链交易'} data-sentry-element="RootHeader" data-sentry-source-file="outCrypto.tsx" />
    <ContentTabs active="crypto_trading" data-sentry-element="ContentTabs" data-sentry-source-file="outCrypto.tsx" />
    <div className={styles.main}>
      <div className={styles.posterWrapper} onClick={showDialog}>
        <img className={cn(styles.poster)} src={tradePoster} alt="poster" />
      </div>
    </div>
    <div>

      <div className={moduelStyles.header}>
        <FormTabs active="ChangeUsdt" data-sentry-element="FormTabs" data-sentry-source-file="outCrypto.tsx" />
        <div style={{
          flex: 1
        }} />
      </div>

      <div className={moduelStyles.form}>
        <DynamicForm disabled={logic.isTrading} data={logic.data} dictMap={logic.dictMap} items={changeUsdtFormItems} onRef={logic.onFormRef} onValuesChange={logic.onValuesChange} data-sentry-element="DynamicForm" data-sentry-source-file="outCrypto.tsx" />
      </div>

      <p className={moduelStyles.goHelp}><a onClick={() => navidate('/helps?index=7')}>交易所操作教程</a></p>
      {formFooter}
      <FooterTips data-sentry-element="FooterTips" data-sentry-source-file="outCrypto.tsx" />
    </div>

    <div className={styles.whitespace}></div>
  </div>;
};
export const ChangeOutCrypto = () => {
  return <CryptoTradingProvider data-sentry-element="CryptoTradingProvider" data-sentry-component="ChangeOutCrypto" data-sentry-source-file="outCrypto.tsx">
    <Wrapper data-sentry-element="Wrapper" data-sentry-source-file="outCrypto.tsx" />
  </CryptoTradingProvider>;
};